import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { getIn, setIn } from 'formik';

import SrUserSettingDropdown from 'client/components/SrUserSettingDropdown';
import ButtonDeprecated, { BUTTON_THEME_BLUE } from 'client/components/ButtonDeprecated';

import branch from 'client/core/branch';
import UserActions from 'client/actions/User';

export const SR_USER_SETTING_LISTING_MANAGEMENT_COMPANY_FILTER_BY_ALL =
  'SR_USER_SETTING_LISTING_MANAGEMENT_COMPANY_FILTER_BY_ALL'; // eslint-disable-line max-len

@branch({
  partnersList: ['partners', 'list'],
})
class SrUserSettingListingManagementCompanyDropdown extends Component {
  static propTypes = {
    currentUser: PropTypes.object.isRequired,
    partnersList: PropTypes.array,
    dispatch: PropTypes.func.isRequired,
    settingField: PropTypes.string.isRequired,
    placeholder: PropTypes.string,
    allPartners: PropTypes.bool,
    resetAccountManagerUserId: PropTypes.bool,
  };

  static defaultProps = {
    placeholder: 'partners',
    allPartners: false,
  };

  static getDerivedStateFromProps(props, state) {
    const settingValue = getIn(props.currentUser.settings, props.settingField);
    if (settingValue !== state.settingValue) {
      return {
        settingValue: settingValue,
        settingValueTemporal: settingValue,
      };
    }

    return null;
  }

  constructor(props) {
    super(props);

    const settingValue = getIn(props.currentUser.settings, props.settingField);

    this.state = {
      settingValue: settingValue,
      settingValueTemporal: settingValue,
    };
  }

  _onChangeListingManagementCompany = (listingManagementCompany) => {
    const { settingValueTemporal } = this.state;

    if (listingManagementCompany === undefined) {
      this.setState({ settingValueTemporal: undefined });
    } else if (
      listingManagementCompany === SR_USER_SETTING_LISTING_MANAGEMENT_COMPANY_FILTER_BY_ALL
    ) {
      this.setState({ settingValueTemporal: listingManagementCompany });
    } else if (settingValueTemporal === SR_USER_SETTING_LISTING_MANAGEMENT_COMPANY_FILTER_BY_ALL) {
      this.setState({ settingValueTemporal: [listingManagementCompany] });
    } else if (Array.isArray(settingValueTemporal)) {
      this.setState({
        settingValueTemporal: settingValueTemporal.includes(listingManagementCompany)
          ? settingValueTemporal.filter((id) => id !== listingManagementCompany)
          : [...settingValueTemporal, listingManagementCompany],
      });
    } else {
      this.setState({
        settingValueTemporal: settingValueTemporal
          ? [settingValueTemporal, listingManagementCompany]
          : [listingManagementCompany],
      });
    }
  };

  _onSaveListingManagementCompany = () => {
    const { currentUser, settingField, dispatch, resetAccountManagerUserId } = this.props;
    const { settingValueTemporal } = this.state;
    const newUserSettings = setIn({ ...currentUser.settings }, settingField, settingValueTemporal);

    if (resetAccountManagerUserId) {
      newUserSettings.appProSettings.accountManagerUserId = undefined;
    }
    this.setState({ settingValue: settingValueTemporal });
    dispatch(UserActions.updateSettings, newUserSettings);
  };

  render() {
    const {
      settingField,
      currentUser,
      partnersList,
      dispatch,
      placeholder,
      allPartners,
    } = this.props;

    const { settingValue, settingValueTemporal } = this.state;

    const options = [
      ...(allPartners
        ? [
            {
              label: 'all',
              value: undefined,
            },
          ]
        : [
            {
              label: 'everyone',
              value: undefined,
            },
            {
              label: 'all partners',
              value: SR_USER_SETTING_LISTING_MANAGEMENT_COMPANY_FILTER_BY_ALL,
            },
            {
              label: 'non partners',
              value: null,
            },
          ]),
      ...(partnersList || [])
        .filter((partner) => !partner.invalidSignup)
        .map((option) => ({
          label: option.displayName,
          value: option.managementCompanyName,
        })),
    ];

    const settingValueArray = Array.isArray(settingValue) ? settingValue : [settingValue];
    const optionsActive = options
      .filter((option) => settingValueArray.includes(option.value))
      .map(({ label }) => label)
      .join(', ');
    const title = `${placeholder}: ${optionsActive || '...'}`;

    return (
      <SrUserSettingDropdown
        user={currentUser}
        settingField={settingField}
        settingValue={settingValueTemporal}
        title={title}
        options={options}
        onChange={this._onChangeListingManagementCompany}
        dispatch={dispatch}
        shouldUpdateSettings={false}
        multiple
        footer={
          <div className="buttonContainer">
            <ButtonDeprecated
              theme={BUTTON_THEME_BLUE}
              type="button"
              onClick={this._onSaveListingManagementCompany}
            >
              save
            </ButtonDeprecated>
          </div>
        }
      />
    );
  }
}

SrUserSettingListingManagementCompanyDropdown.displayName =
  'SrUserSettingListingManagementCompanyDropdown';

export default SrUserSettingListingManagementCompanyDropdown;
